import React, { useState, useEffect } from "react";
import { Modal, Input, Button, message, Popconfirm } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import { GrFormAdd } from "react-icons/gr";
import { MdEdit, MdDelete, MdRefresh } from "react-icons/md";
import axios from "axios";
import { API, Headers } from "../../../../Config";

import DataTable from "./DataTable";
import FormModal from "./FormModal";
import { IoIosClose } from "react-icons/io";

const { Search } = Input;
function FormShipperModal(props) {
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState("post");

  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState([]);

  const [addShipperModal, setAddShipperModal] = useState(false);

  useEffect(() => {
    loaddata(page, take);
  }, []);
  const loaddata = (p, t) => {
    axios
      .get(API.BASR_URL + API.SENDERS_LIST + `?order=ASC&page=${p}&take=${t}`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setData(data.data);
          setMeta(data.meta);

          message.success("Success");
        } else {
          message.error("Oops.Something went wrong");
        }
        setLoading(false);
      })
      .catch(function (error) {
        message.error("Oops.Something went wrong");
        setLoading(false);
      });
  };

  const reload = () => {
    setIndicator(true);
    loaddata(page, take);
    setAddShipperModal(false);
  };

  const AddNew = () => {
    setSelected([]);
    setAddShipperModal(true);
    setMode("post");
  };

  const UpdateItem = () => {
    setMode("put");
    setAddShipperModal(true);
  };

  const selectCell = (row) => {
    setSelected(row);
  };

  const deleteCell = () => {
    const RowID = selected && selected[0].id;
    axios
      .delete(API.BASR_URL + API.SENDERS_ACTION + RowID, {
        headers: Headers(),
      })
      .then(function (response) {
        message.success("Deleted Successfully");
        reload();
      })
      .catch(function (error) {
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  const Submit = () => {
    props.onChange(selected);
    props.onClose();
  };

  const pagination = (page, take) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    setPage(page);
    setTake(take);
    loaddata(page, take);
  };

  const onSearch = (value) => {
    axios
      .get(API.BASR_URL + API.SENDERS_ACTION + "like/" + value, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setData(data);
        } else {
          message.error("Oops.Something went");
        }
      });
  };

  return (
    <Modal
      visible={props.visible}
      onCancel={props.onClose}
      onClose={props.onClose}
      footer={false}
      width={800}
    >
      <h5 className="PrintLabelModal-txt1">CONTACT FINDER</h5>
      <Container style={{ display: "flex" }}>
        <Search
          placeholder=""
          allowClear
          style={{ flex: 0.4 }}
          onSearch={onSearch}
        />
        <div
          className="find-customer-modal-close-button"
          onClick={() => loaddata(page, take)}
          style={{ marginRight: 3 }}
        >
          <IoIosClose size={30} />
        </div>

        <Button type="primary" icon={<GrFormAdd />} onClick={() => AddNew()}>
          Add
        </Button>

        <Button
          icon={<MdEdit />}
          disabled={selected.length ? false : true}
          onClick={() => UpdateItem()}
        >
          Edit
        </Button>

        <Popconfirm
          placement="bottomRight"
          title={"Are you sure to delete?"}
          okText="Yes"
          cancelText="No"
          onConfirm={deleteCell}
        >
          <Button icon={<MdDelete />} disabled={selected.length ? false : true}>
            Remove
          </Button>
        </Popconfirm>
      </Container>
      <br />
      <DataTable
        data={data}
        loading={loading}
        selected={selected}
        onSelect={(data) => selectCell(data)}
        PageOnchange={(page, take) => pagination(page, take)}
      />
      <br />
      <Row>
        <Col sm="6"></Col>
        <Col sm="3">
          <Button type="primary" block onClick={() => Submit()}>
            Select
          </Button>
        </Col>
        <Col sm="3">
          <Button onClick={props.onClose} block>
            Cancel
          </Button>
        </Col>
      </Row>
      {addShipperModal ? (
        <FormModal
          data={data}
          mode={mode}
          visible={addShipperModal}
          selected={selected}
          reload={reload}
          onClose={() => setAddShipperModal(false)}
        />
      ) : null}
    </Modal>
  );
}

export default FormShipperModal;
